export default __webpack_public_path__ + "static/media/KitchenDisplaySystem2.efed1593.png";